<template>
  <nav
    class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div
          v-if="
            roles.some(
              (r) =>
                r === 'psp.admin.clientes.wee' ||
                r === 'psp.config.clientes.wee'
            )
          "
          class="mx-2"
        >
          <ChangeCliente />
        </div>

        <div class="mx-2">
          <ChangeClienteCuenta />
        </div>
      </div>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
      </button>

      <div class=" navbar-collapse justify-content-end">
        <!-- Notificaciones -->
        <span>
          <v-menu
            open-on-click
            bottom
            left
            offset-y
            max-width="380"
            content-class="campana-menu"
            transition="scroll-y-transition"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                class="relative mr-3"
                color="primary"
                dark
                x-small
                fab
                v-bind="attrs"
                v-on="{ ...menu }"
                @click="actualizarAvisos()"
              >
                <v-icon dark small>mdi-bell</v-icon>
                <v-badge
                  color="transparent"
                  overlap
                  v-if="avisosNl.length !== 0"
                >
                  <span
                    class="absolute top-0 right-0 -mt-5 -mr-3 custom-badge"
                    >{{ avisosNl.length }}</span
                  >
                </v-badge>
              </v-btn>
            </template>

            <div>
              <v-card width="380" class="campana">
                <div class="campana__head">
                  <span class="campana__titulo">Notificaciones</span>
                  <span v-if="avisosNl.length" class="campana__cuenta"
                    >{{ avisosNl.length }} {{ avisosNl.length === 1 ? "nueva" : "nuevas" }}</span
                  >
                  <v-btn
                    v-if="avisosNl.length"
                    small
                    text
                    color="teal darken-2"
                    class="campana__todas ml-auto"
                    @click="marcarTodas"
                  >
                    <v-icon small left>mdi-check-all</v-icon>Marcar todas
                  </v-btn>
                </div>
                <div class="campana__lista">
                  <div v-if="cargandoNl && !avisosNl.length" class="campana__vacio">
                    <v-progress-circular
                      indeterminate
                      color="teal"
                      :size="24"
                      :width="2"
                    ></v-progress-circular>
                  </div>
                  <div v-else-if="avisosNl.length === 0" class="campana__vacio">
                    <v-icon size="36" color="grey lighten-1"
                      >mdi-bell-sleep-outline</v-icon
                    >
                    <p>Estás al día</p>
                  </div>
                  <template v-else>
                    <template v-for="(aviso, index) in avisosNl">
                      <div
                        v-if="!aviso.leido && index < 4"
                        :key="aviso.id"
                        class="campana__item campana__item--nuevo"
                        @click="abrirModal(aviso)"
                      >
                        <div class="campana__texto">
                          <strong
                            ><v-icon x-small color="#1db6c8" class="campana__ico"
                              >mdi-bullhorn-outline</v-icon
                            >{{ aviso.nombre }}<span class="campana__nueva">NUEVA</span></strong
                          >
                          <span class="campana__desc">{{ aviso.descripcion }}</span>
                          <div
                            v-if="imagenesDe(aviso).length || otrosDe(aviso).length"
                            class="campana__imgs"
                          >
                            <span
                              v-for="(im, i) in imagenesDe(aviso).slice(0, 3)"
                              :key="i"
                              class="campana__img"
                            >
                              <img
                                v-if="!imgRota(im)"
                                :src="im.url"
                                :alt="im.nombre || aviso.nombre"
                                loading="lazy"
                                @error="marcarRota(im)"
                              />
                              <span v-if="i === 2 && imagenesDe(aviso).length > 3" class="campana__mas"
                                >+{{ imagenesDe(aviso).length - 3 }}</span
                              >
                            </span>
                            <span
                              v-for="(f, i) in otrosDe(aviso)"
                              :key="'f' + i"
                              class="campana__img campana__arch"
                              :title="f.nombre"
                            >
                              <v-icon size="20" :color="colorArchivo(f)">{{ iconoArchivo(f) }}</v-icon>
                              <small>{{ extArchivo(f) }}</small>
                            </span>
                          </div>
                          <small :title="'Creada: ' + fechaCreacion(aviso)">{{ tiempoRelativo(fechaBase(aviso)) }}</small>
                        </div>
                        <v-tooltip left content-class="tip-solido">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              small
                              v-on="on"
                              @click.stop="cambiarLeido(aviso.avisos_id, aviso.leido)"
                            >
                              <v-icon small color="teal darken-1"
                                >mdi-check-circle-outline</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>Marcar como leída</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </template>
                </div>
                <div class="campana__pie">
                  <v-btn
                    depressed
                    block
                    to="/notificaciones"
                    class="campana__anteriores"
                    >Ver avisos anteriores</v-btn
                  >
                </div>
              </v-card>
            </div>
          </v-menu>
        </span>

        <!-- Modal de Card -->
        <v-dialog v-model="vistaModal" max-width="520" scrollable>
          <v-card v-if="selectedAviso" class="campana-modal">
            <div class="campana-modal__head">
              <div class="campana-modal__titulo">
                <h2>{{ selectedAviso.nombre }}</h2>
                <span v-if="fechaCreacion(selectedAviso)">{{
                  fechaCreacion(selectedAviso)
                }}</span>
              </div>
              <v-btn icon small aria-label="Cerrar" @click="vistaModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text class="campana-modal__body">
              <p class="campana-modal__txt">{{ selectedAviso.descripcion }}</p>
              <div
                v-if="imagenesSel.length"
                class="campana-modal__galeria"
                :class="'campana-modal__galeria--' + Math.min(imagenesSel.length, 3)"
              >
                <button
                  v-for="(im, i) in imagenesSel.slice(0, 6)"
                  :key="i"
                  type="button"
                  class="campana-modal__foto"
                  :aria-label="'Ver imagen ' + (im.nombre || i + 1)"
                  @click="abrirVisor(i)"
                >
                  <img
                    v-if="!imgRota(im)"
                    :src="im.url"
                    :alt="im.nombre || selectedAviso.nombre"
                    @error="marcarRota(im)"
                  />
                  <v-icon v-else color="grey lighten-1">mdi-image-broken-variant</v-icon>
                  <span v-if="i === 5 && imagenesSel.length > 6" class="campana-modal__mas"
                    >+{{ imagenesSel.length - 6 }}</span
                  >
                </button>
              </div>
              <div v-if="otrosSel.length" class="campana-modal__adj">
                <a
                  v-for="(f, i) in otrosSel"
                  :key="i"
                  :href="f.url_descarga || f.url || undefined"
                  download
                  target="_blank"
                  rel="noopener"
                  class="campana-modal__archivo"
                  :class="{ 'campana-modal__archivo--off': !(f.url_descarga || f.url) }"
                >
                  <v-icon small color="teal darken-1">{{ iconoArchivo(f) }}</v-icon>
                  <span class="campana-modal__adjnombre">{{ f.nombre }}</span>
                  <small>{{ formatTamano(f.tamano) }}</small>
                  <v-icon small color="grey">mdi-download</v-icon>
                </a>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-4 py-3">
              <v-spacer></v-spacer>
              <v-btn
                color="teal darken-1"
                depressed
                dark
                class="campana-modal__ok"
                @click="cerrarModal(selectedAviso.avisos_id, selectedAviso.leido)"
                >Entendido</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <VisorImagenes v-model="visor" :aviso="selectedAviso" :index="visorIdx" />

        <div>{{ $store.state.email }}</div>

        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a
              class="nav-link"
              href="javascript:;"
              id="navbarDropdownProfile"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style="color: white"
            >
              <i class="material-icons">person</i>
              <p class="d-lg-none d-md-block">Account</p>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbarDropdownProfile"
            >
              <a v-show="permisos.some((p) => p === 'usuario.update')">
                <router-link class="dropdown-item" to="/perfil">
                  Perfil
                </router-link>
              </a>
              <a>
                <router-link class="dropdown-item" to="/general">
                  General
                </router-link>
              </a>
              <a v-show="permisos.some((p) => p === 'psp.consultar.cuentas')">
                <router-link class="dropdown-item" to="/preference">
                  Checkout
                </router-link>
              </a>
              <div class="dropdown-divider"></div>
              <a
                href="#"
                class="dropdown-item"
                @click="$store.commit('logout')"
              >
                Cerrar sesión
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import ChangeClienteCuenta from "@/components/Administrar/ChangeClienteCuenta.vue";
import VisorImagenes from "@/components/Avisos/VisorImagenes.vue";
import ChangeCliente from "@/components/Administrar/ChangeCliente.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import { Notificaciones } from "../../services/notificaciones.js";
import { tiempoRelativo } from "../../utils/tiempoRelativo.js";
import {
  fechaCreacion,
  fechaBase,
  formatTamano,
  iconoArchivo,
  colorArchivo,
  archivosDe,
} from "../../utils/avisos.js";

export default {
  name: "Nav",
  components: {
    VisorImagenes,
    ChangeClienteCuenta,
    ChangeCliente,
  },
  data() {
    return {
      vistaModal: false,
      selectedAviso: null,
      showBadge: true,
      leidos: 0,
      leido: "",
      imgRotas: {},
      visor: false,
      visorIdx: 0,
    };
  },

  filters: {
    truncate(value, maxLength) {
      if (value.length > maxLength) {
        return value.substring(0, maxLength) + "...";
      } else {
        return value;
      }
    },
  },

  computed: {
    ...mapGetters(["isSuperAdmin", "permisos", "roles", "getUserId"]),
    imagenesSel() {
      return archivosDe(this.selectedAviso).filter((a) => a.es_imagen && a.url);
    },
    otrosSel() {
      return archivosDe(this.selectedAviso).filter((a) => !a.es_imagen);
    },
    ...mapState("notificaciones", [
      "avisosNl",
      "page",
      "total",
      "visible",
      "rowsPerPage",
      "cargandoNl",
    ]),
    /*  mostrar() {
      const rutas = [
        "/general",
        "/movimientos",
        "/pagos",
        "/transferencias",
        "/reportes",
        "/contracargos",
        "/preference",
        "/reportes-cobranzas",
        "/reportes-rendiciones",
        "/reportes-retenciones",
        "/reportes-reversiones",
        "/reporte-movimiento",
      ];
      return rutas.includes(this.$route.path);
    }, */
  },
  methods: {
    avisosLeidos() {
      // Filtra los avisos donde no leidos es igual a false
      this.leidos = this.avisosNl.filter((aviso) => !aviso.leidos);
      this.leidos = this.leidos.length;
      // Muestra la cantidad de avisos no leídos en la consola
    },
    async marcarTodas() {
      for (const a of [...this.avisosNl]) {
        await this.cambiarLeido(a.avisos_id, a.leido);
      }
    },
    fechaCreacion,
    fechaBase,
    tiempoRelativo,
    formatTamano,
    iconoArchivo,
    colorArchivo,
    otrosDe(aviso) {
      return archivosDe(aviso).filter((a) => !a.es_imagen);
    },
    extArchivo(f) {
      return (f.nombre.split(".").pop() || "").slice(0, 4).toUpperCase();
    },
    imagenesDe(aviso) {
      return archivosDe(aviso).filter((a) => a.es_imagen && a.url);
    },
    imgRota(img) {
      return !img.url || !!this.imgRotas[img.url];
    },
    marcarRota(img) {
      this.$set(this.imgRotas, img.url, true);
    },
    actualizarAvisos() {
      this.getAvisosNoleidos();
    },

    ...mapActions("notificaciones", ["getAvisos", "getAvisosNoleidos"]),
    //Para abrir Modal de Card
    abrirVisor(i) {
      this.visorIdx = i;
      this.visor = true;
    },
    abrirModal(aviso) {
      this.selectedAviso = aviso;
      this.leido = this.selectedAviso.leido;
      this.vistaModal = true;
    },
    cerrarModal(id, read) {
      this.cambiarLeido(id, read);
      this.selectedAviso = null;
      this.vistaModal = false;
    },
    //Camnbiar a Leido aviso
    async cambiarLeido(id, read) {
      if (!read) {
        try {
          const params = { AvisoId: id, UserId: parseInt(this.getUserId) };
          const response = await Notificaciones.putCambiarEstadoAviso(params);
          this.getAvisos();
          this.getAvisosNoleidos();
          return response;
        } catch (error) {
          this.$toastr.e("No se pudo marcar la notificación como leída");
        }
      }
    },
  },
  created() {
    if (this.getUserId) {
        this.getAvisosNoleidos();
    }
    // refresco periodico para que la campana avise sola
    this.timerAvisos = setInterval(() => {
      if (this.getUserId && !document.hidden) this.getAvisosNoleidos();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.timerAvisos);
  },
  mounted() {
    this.getAvisosNoleidos;
    this.avisosLeidos();
  },
};
</script>
<style>
.tip-solido { white-space: nowrap; background: #263238 !important; opacity: 1 !important; color: #fff; font-size: 0.78rem; padding: 6px 10px; border-radius: 6px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3); }
</style>
<style scoped>
.campana__head { display: flex; align-items: center; gap: 8px; padding: 10px 10px 10px 16px; background: #fff; border-bottom: 1px solid #e3e9ed; }
.campana__titulo { font-size: 1.05rem; font-weight: 700; color: #263238; }
.campana__cuenta { padding: 2px 10px; border-radius: 12px; background: #1db6c8; color: #fff; font-size: 0.78rem; font-weight: 700; line-height: 1.4; }
.campana-modal__ok { text-transform: none !important; letter-spacing: 0 !important; font-size: 0.9rem !important; font-weight: 600 !important; border-radius: 8px !important; min-width: 110px !important; }
.campana__todas { text-transform: none !important; letter-spacing: 0 !important; font-size: 0.85rem !important; font-weight: 600 !important; }
.campana { border-radius: 10px !important; overflow: hidden; }
.campana__pie { padding: 8px 12px 12px; background: #fff; }
.campana__anteriores { height: 40px !important; border-radius: 8px !important; background: #e0f2f6 !important; color: #0b7285 !important; font-weight: 600; letter-spacing: 0 !important; text-transform: none !important; font-size: 0.9rem; }
.campana__anteriores:hover { background: #cfe9ef !important; }
.campana__lista { max-height: 380px; overflow-y: auto; }
.campana__vacio { text-align: center; padding: 28px 0; color: #9e9e9e; font-size: 0.85rem; }
.campana__vacio p { margin: 6px 0 0; }
.campana__item { display: flex; align-items: flex-start; gap: 12px; padding: 12px 16px; cursor: pointer; border-bottom: 1px solid #eee; transition: background 0.15s; }
.campana__item--nuevo { background: #f3f9fb; box-shadow: inset 4px 0 0 #1db6c8; }
.campana__nueva { display: inline-block; margin-left: 6px; padding: 0 6px; border-radius: 8px; background: #e0f2f6; color: #0b7285; font-size: 0.6rem; font-weight: 700; letter-spacing: 0.06em; vertical-align: 1px; }
.campana__item:hover { background: #dff2fb; }
.campana__texto { display: flex; flex-direction: column; text-align: left; min-width: 0; flex: 1; }
.campana__ico { margin-right: 4px; vertical-align: -1px; }
.campana__imgs { display: flex; gap: 4px; margin-top: 6px; }
.campana__img { position: relative; display: block; width: 64px; height: 48px; border-radius: 6px; overflow: hidden; background: #f1f1f1; flex-shrink: 0; }
.campana__img img { width: 100%; height: 100%; object-fit: cover; display: block; }
.campana__imgs { flex-wrap: wrap; }
.campana__arch { display: flex; flex-direction: column; align-items: center; justify-content: center; border: 1px solid #e3e9ed; background: #f6f8f9; }
.campana__arch small { font-size: 0.6rem; font-weight: 700; color: #607d8b; line-height: 1; }
.campana__mas { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.5); color: #fff; font-size: 0.85rem; font-weight: 600; }
.campana-modal__head { display: flex; align-items: flex-start; gap: 8px; padding: 16px 12px 12px 20px; border-bottom: 1px solid #eee; }
.campana-modal__titulo { flex: 1; min-width: 0; text-align: left; }
.campana-modal__titulo h2 { margin: 0; font-size: 1.1rem; font-weight: 700; color: #222; word-break: break-word; }
.campana-modal__titulo span { font-size: 0.78rem; color: #8a959b; }
.campana-modal__body { padding: 16px 20px !important; text-align: left; }
.campana-modal__txt { margin: 0 0 12px; white-space: pre-line; word-break: break-word; font-size: 0.95rem; color: #333; line-height: 1.45; }
.campana-modal__galeria { display: grid; gap: 4px; margin-bottom: 12px; }
.campana-modal__galeria--1 { grid-template-columns: 1fr; }
.campana-modal__galeria--2 { grid-template-columns: 1fr 1fr; }
.campana-modal__galeria--3 { grid-template-columns: 1fr 1fr 1fr; }
.campana-modal__foto { position: relative; display: flex; align-items: center; justify-content: center; padding: 0; border: 0; border-radius: 10px; overflow: hidden; cursor: zoom-in; background: #f1f1f1; height: 110px; }
.campana-modal__galeria--1 .campana-modal__foto { height: auto; max-height: 280px; }
.campana-modal__foto img { width: 100%; height: 100%; object-fit: cover; display: block; }
.campana-modal__galeria--1 .campana-modal__foto img { height: auto; max-height: 280px; }
.campana-modal__mas { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.5); color: #fff; font-size: 1.3rem; font-weight: 600; }
.campana-modal__adj { display: flex; flex-direction: column; gap: 6px; }
.campana-modal__archivo { display: flex; align-items: center; gap: 8px; padding: 8px 10px; border: 1px solid #e3eef1; border-radius: 8px; background: #f7fbfc; text-decoration: none !important; }
.campana-modal__archivo:hover { background: #ecf6f9; }
.campana-modal__archivo--off { pointer-events: none; opacity: 0.6; }
.campana-modal__adjnombre { flex: 1; min-width: 0; font-size: 0.85rem; color: #333; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.campana-modal__archivo small { color: #757575; white-space: nowrap; }
.campana__fila { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.campana__texto strong { font-size: 0.88rem; font-weight: 700; color: #222; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.campana__texto small { font-size: 0.7rem; color: #0b7285; font-weight: 600; margin-top: 2px; }
.campana__desc { font-size: 0.78rem; color: #666; margin-top: 2px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
/* Estilo personalizado para el badge */
.custom-badge {
  background-color: #64b5f6; /* Color celeste */
  color: white; /* Color del texto */
  font-size: 10px; /* Tamaño del texto */
  width: 16px; /* Ancho del badge */
  height: 16px; /* Altura del badge */
  border-radius: 50%; /* Hace que el badge sea circular */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style>
.campana-menu { border-radius: 10px !important; box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16) !important; }
</style>
